import { useEffect, useState } from 'react';

// Below this width the sidebar collapses to a slide-in drawer so the
// content pane has room to breathe. 720 is roughly the smallest viewport
// on which the desktop side-by-side layout still feels usable.
export const NARROW_BREAKPOINT_PX = 720;

export function useNarrow(threshold = NARROW_BREAKPOINT_PX): boolean {
  const [narrow, setNarrow] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${threshold - 1}px)`);
    setNarrow(mq.matches);
    const update = () => setNarrow(mq.matches);
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, [threshold]);
  return narrow;
}
